export default {
    MOBILE: 768,
    TABLET: 1100
};
